import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';
import { prepareFilterParams, prepareOptionFilterParams } from '@/libs/helper';

const resource = `${Config.basePath}/v1/admin/supplier`;

export default {
  index(payload) {
    const params = prepareFilterParams(payload);
    return Client.post(resource, {
      ...params
    }, {
      headers: {
        action: "list",
      },
    });
  },
  show(id) {
    return Client.post(resource, {
      id: id,
    }, {
      headers: {
        action: "show",
      },
    });
  },
  create(payload) {
    const params = {
      ...payload,
    };
    return Client.post(resource, params, {
      headers: {
        action: "store",
      },
    });
  },
  update(id, payload) {
    const params = {
      ...payload,
      id: id,
    };
    return Client.post(resource, params, {
      headers: {
        action: "update",
      },
    });
  },
  options(payload) {
    const queries = [{
      searchby: "name",
      searchoperator: "%",
      search: payload.search
    }];
    const params = prepareOptionFilterParams(payload, queries);
    return Client.post(resource, params, {
      headers: {
        action: "option",
      },
    });
  },
};
